import { MASK } from '../../../../constants/mask';

export const REQUISITES_FIELDS = {
  dcName: 'name',
  bin: 'bin',
  address: 'address',
  iban: 'iban',
  bankName: 'bankName',
  bic: 'bic',
};

export const REQUISITES_INPUTS = [
  {
    name: 'dcName',
    label: 'Наименование дилерского центра',
    placeholder: 'ТОО «...»',
    rules: { required: true },
  },
  {
    name: 'bin',
    label: 'БИН',
    placeholder: '000000000000',
    mask: MASK.IIN,
    rules: { required: true },
  },
  {
    name: 'address',
    label: 'Юридический адрес',
    placeholder: 'г. Алматы, ул. ...',
    rules: { required: true },
  },
  {
    name: 'iban',
    label: 'Номер банковского счёта (IBAN)',
    placeholder: 'KZ00000000000000000',
    mask: MASK.IBAN,
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/_/g, '');
        return clean.length === 20 || 'Номер счёта должен содержать 20 символов';
      },
    },
  },
  {
    name: 'bankName',
    label: 'Наименование банка',
    placeholder: 'АО «Банк»',
    rules: { required: true },
  },
  {
    name: 'bic',
    label: 'БИК',
    placeholder: 'KCJBKZKX',
    maxLength: 8,
    transform: (value) => value?.toUpperCase(),
    rules: {
      required: true,
      validate: (value) => (value || '').replace(/_/g, '').length === 8 || 'БИК должен содержать 8 символов',
    },
  },
];

export const SELLER_REQUISITES_INPUTS = [
  {
    name: 'recipient',
    label: 'Получатель',
    placeholder: 'ФИО, как в банке',
    rules: { required: true },
  },
  {
    name: 'iban',
    label: 'IBAN продавца',
    placeholder: 'KZ000000000000000000',
    mask: MASK.IBAN,
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/[_ ]/g, '').toUpperCase();
        return /^KZ[0-9A-Z]{18}$/.test(clean) || 'Казахстанский IBAN — KZ и 18 символов';
      },
    },
  },
  {
    name: 'bankName',
    label: 'Банк продавца',
    placeholder: 'АО «Банк»',
    rules: { required: true },
  },
  {
    name: 'bic',
    label: 'БИК / BIC продавца',
    placeholder: 'KCJBKZKX',
    maxLength: 11,
    transform: (value) => value?.toUpperCase(),
    rules: {
      required: true,
      validate: (value) => {
        const clean = (value || '').replace(/[_ ]/g, '').toUpperCase();
        return /^[A-Z]{8}([A-Z0-9]{3})?$/.test(clean) || 'БИК — 8 латинских или SWIFT на 11';
      },
    },
  },
];

export const sellerFio = (seller) => {
  const client = seller?.client || seller;
  if (!client) return seller?.label || '';
  return [client.surname, client.name, client.middlename].filter(Boolean).join(' ').trim();
};

export const withDefaults = (inputs, values) =>
  inputs.map((item) => ({ ...item, defaultValue: values?.[item.name] ?? '' }));

export const cleanBank = (value) => String(value || '').replace(/[_ ]/g, '').toUpperCase();
